// extracted by mini-css-extract-plugin
module.exports = {"room":"room_room__10xuN","name":"room_name__7bHrY","nameGroup":"room_nameGroup__zAl86","joinButton":"room_joinButton__3Eijj","expandButton":"room_expandButton__mxLcR"};